import { httpBasic, http } from 'http';

export default {
  getMarkdownFile: url =>
    httpBasic.get(url, {
      headers: {
        Accept: 'text/x-markdown'
      }
    }),

  getPartnerData: id => http.get(`/basics/${id}`)
};
